import { Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation } from '@angular/core';
import { timer, combineLatest } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { ComponentBase } from '../../../../../base-classes/componet-base';
import { PrifactRoute } from '../../../../../models/prifact-route';
import { Student } from '../../../../../models/student';
import { PageHeadingService } from '../../../../../services/page-heading-service/page-heading.service';
import { RoutingService } from '../../../../../services/routing-service/routing.service';
import { WardsService } from '../../../../../services/wards-service/wards.service';
import { AuthService } from '../../../../auth/services/auth.service';
import { FeeSummary } from '../../../../pages/fees/models/fee-summary';
import { FeesService } from '../../../../pages/fees/services/fees.service';
import { MessageCountService } from '../../../../pages/messages/services/message-count-service/message-count.service';
import { bottomMenuList } from '../../models/bottom-menu-list';
import { Menu } from '../../models/menu';
import { menuList } from '../../models/menulist';
import { UserContext } from '../../../../../models/user-context';
import { AppSettings } from '../../../../../utils/app-settings';
import { LocalStorageService } from '../../../../../services/local-storage-service/local-storage.service';
declare var dynamics;
declare var platform;
declare var window: any;

@Component({
  selector: 'app-bottom-menu',
  templateUrl: './bottom-menu.component.html',
  styleUrls: ['./bottom-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class BottomMenuComponent extends ComponentBase implements OnInit {

  constructor(private renderer: Renderer2
    , private routingService: RoutingService
    , private pageHeadingService: PageHeadingService
    , private authService: AuthService
    , private messageCountService: MessageCountService
    , private wardsService: WardsService
    , private feesService: FeesService
    , private localStorageService: LocalStorageService) {
    super();
  }
  bottomMenuList = bottomMenuList;
  menuList = menuList;
  showMenuList: boolean = false;
  readyToCollapse: boolean = false;
  selectedMenuItem: Menu;
  messageCount: number;
  selectedProfile: Student;;
  upcomingFeeInstallment: FeeSummary;
  wards: Student[];
  selectedWard: Student;
  showStudentList: boolean = false;

  @ViewChild('pullupMenu', { static: true }) pullupMenu: ElementRef;
  ngOnInit() {
    let sub = this.pageHeadingService.menu$
      .subscribe(menu => {
        this.selectedMenuItem = menu;
      });
    this.addSubscription(sub);
    this.menuList = this.menuList.filter(n => !this.bottomMenuList.find(o => o.name == n.name));

    let sub2 = timer(0, 20000).pipe(
      switchMap(res => {
        return this.messageCountService.getUnreadMessageCount()
      }))
      .subscribe(count => {
        this.messageCount = count;
      });
    this.addSubscription(sub2);

    let sub3 = combineLatest(this.wardsService.wards$, this.wardsService.ward$)
      .subscribe(([wards, ward]) => {
        this.wards = wards.filter(o => o.student_id != ward.student_id);
        this.selectedWard = ward;
      });
    this.addSubscription(sub3);

    let sub4 = this.feesService.subscribeToUpcomigFeeInstallment()
      .subscribe(res => {
        this.upcomingFeeInstallment = res;
      });
    this.addSubscription(sub4);
  }

  toggleStudentList() {
    this.showStudentList = !this.showStudentList;
  }

  menuClicked(menu: Menu) {
    let route = new PrifactRoute
    route.url = "/pages/" + menu.route;
    route.clear_history = true;
    route.page_name = menu.name;
    this.routingService.navigate(route);
    this.clickOutSide();
  }

  hamburgerMenuBtnClicked() {
    this.renderer.addClass(document.body, 'modal-open');
    dynamics.animate(this.pullupMenu.nativeElement, {
      scrollTop: window.innerHeight / 1.25,
    }, {
      type: dynamics.easeOut,
      duration: 200,
      friction: 50,
      complete: this.readyToCollapse = true
    });
  }


  onScroll(e) {
    setTimeout(() => {
      if (this.readyToCollapse) {
        if ((e.target.scrollTop < window.innerHeight / 3)) {
          this.readyToCollapse = false;
          this.clickOutSide();
        }
      }
    }, 100);
    if ((e.target.scrollTop > window.innerHeight - 25)) {
      this.renderer.addClass(document.body, 'menu-reached-top');

    } else {
      this.renderer.removeClass(document.body, 'menu-reached-top');
    }
  }

  collapseMenu(obj) {
    obj.readyToCollapse = false;
    setTimeout(() => {
      obj.renderer.removeClass(document.body, 'modal-open');
    }, 100);
  }
  clickOutSide() {
    dynamics.animate(this.pullupMenu.nativeElement, {
      scrollTop: 0,
    }, {
      type: dynamics.easeIn,
      duration: 100,
      complete: this.collapseMenu(this)
    });
  }


  logout() {
    this.authService.logout().subscribe(res => {
      if (platform != 'browser') {
        let location = window.location.href.split('#')[0];
        location = location.replace('index.html', '');
        window.location.replace(location + 'index.html');
      }
    }, err => {
      console.error(err);
    });
    this.clickOutSide();
  }

  myAccountClicked() {
    let route = new PrifactRoute();
    route.primary_command = ['pages', 'my-account', 'user'];
    route.append_current_url_to_history = true;
    this.routingService.navigate(route);
    this.clickOutSide();
  }

  onSelectWard(ward: Student) {
    let sub = this.authService.authContext$
      .subscribe(authContext => {
        let user_context: UserContext = new UserContext();
        user_context.person_id = authContext.person.person_id;
        user_context.student_id = ward.student_id;
        this.localStorageService.setItem(AppSettings.LocalStorageUserContextKey, user_context);
        this.wardsService.setWard(ward);
        let location = window.location.href.split('#')[0];
        location = location.replace('index.html', '');
        window.location.replace(location + 'index.html');
      });
    this.addSubscription(sub);
  }

  redirectToLogin() {
    let route = new PrifactRoute();
    route.clear_history = true;
    route.url = "/anonymous/login";
    this.routingService.navigate(route);
  }
}
